export const interactions = new Map();